import PropTypes from "prop-types";
import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FormattedMessage, injectIntl } from "react-intl";
import { coalesce } from "../../../utils/ObjectUtils";

function CreateEditActionFieldDialog(props) {
  const { actionField, onChange, onCancel, onSave } = props;

  const newMode = actionField.id === undefined;
  const isFormValid = actionField.name["en"] && actionField.name["de"];

  return (
    <Modal show size="lg">
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={`indicator.management.${newMode ? "new" : "edit"}.action.field`} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup className="mb-3">
          <FormLabel>
            <FormattedMessage id="app.common.name.german" />*
          </FormLabel>
          <FormControl
            name="nameDe"
            value={coalesce(actionField.name.de, "")}
            onChange={(event) => {
              actionField.name.de = event.target.value;
              onChange(actionField);
            }}
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <FormLabel>
            <FormattedMessage id="app.common.name.english" />*
          </FormLabel>
          <FormControl
            name="nameEn"
            value={coalesce(actionField.name.en, "")}
            onChange={(event) => {
              actionField.name.en = event.target.value;
              onChange(actionField);
            }}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          <FormattedMessage id="app.common.action.cancel" />
        </Button>
        <Button onClick={onSave} disabled={!isFormValid}>
          <FormattedMessage id="app.common.action.save" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

CreateEditActionFieldDialog.propTypes = {
  show: PropTypes.bool,
  actionField: PropTypes.object.isRequired,

  locale: PropTypes.string.isRequired,

  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default injectIntl(CreateEditActionFieldDialog);
